import BaseInputField from "../../../components/elements/BaseInputField"
import BaseInputArea from "../../../components/elements/BaseInputArea"
import "dayjs/locale/de"
import BaseSectionHeadline from "../../../components/elements/BaseSectionHeadline"
import { Edit, PlusCircle } from "lucide-react"
import { Form, FormInstance } from "antd"
import { ReportWithRelationsType } from "../types"
import BaseSection from "../../../components/elements/BaseSection"
import BaseDocElement from "../../../components/elements/BaseDocElement"

type ReportDetailInformationProps = {
    displayedReport?: ReportWithRelationsType
    isEditing: boolean
    setIsEditing: (isEditing: boolean) => void
    handleCancel: () => void
    handleEdit: () => void
    form: FormInstance<any>
    handleDownload: (s3Key: string, filename: string) => void
}

export default function ReportDetailInformation(props: ReportDetailInformationProps) {
    console.log(props.displayedReport)
    return (
        <>
            {/* Header with edit buttons */}
            <BaseSection hfull>
                <BaseSectionHeadline
                    label="Bericht Details"
                    icon={
                        props.isEditing ? (
                            <div className="flex gap-2 items-center">
                                <button className="btn btn-sm btn-outline btn-primary cursor-pointer" onClick={props.handleCancel}>
                                    Abbrechen
                                </button>{" "}
                                <button className="btn btn-sm btn-primary cursor-pointer" type="submit">
                                    Speichern
                                </button>
                            </div>
                        ) : (
                            <Edit className="cursor-pointer" onClick={props.handleEdit} />
                        )
                    }
                />
                {/* Report Information */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2">
                    <Form.Item name="date" className="!mb-0 w-full" rules={[{ required: true, message: "Datum ist erforderlich" }]}>
                        <BaseInputField label="Datum" type="date" onChange={() => {}} />
                    </Form.Item>
                    <Form.Item name="objectId" className="!mb-0 w-full" rules={[{ required: true, message: "Objekt ist erforderlich" }]}>
                        <BaseInputField
                            label="Objekt"
                            value={
                             `${props.displayedReport?.objectId.adress?.street} ${props.displayedReport?.objectId.adress?.nr}, ${props.displayedReport?.objectId.adress?.plz} ${props.displayedReport?.objectId.adress?.city}`
                            }
                            type="text"
                            disabled
                            onChange={() => {}}
                        />
                    </Form.Item>
                    <Form.Item name="materialsCount" className="!mb-0 w-full" rules={[{ required: true, message: "Materialien sind erforderlich" }]}>
                        <BaseInputField label="Materialien" disabled type="text" onChange={() => {}} />
                    </Form.Item>
                    <Form.Item name="documentsCount" className="!mb-0 w-full" rules={[{ required: true, message: "Materialien sind erforderlich" }]}>
                        <BaseInputField label="Dokumente" disabled type="text" onChange={() => {}} />
                    </Form.Item>
                    <Form.Item name="createdAt" className="!mb-0 w-full" rules={[{ required: true, message: "Erstellt am ist erforderlich" }]}>
                        <BaseInputField label="Erstellt am" disabled type="text" onChange={() => {}} />
                    </Form.Item>
                    <Form.Item name="updatedAt" className="!mb-0 w-full" rules={[{ required: true, message: "Aktualisiert am ist erforderlich" }]}>
                        <BaseInputField label="Aktualisiert am" disabled type="text" onChange={() => {}} />
                    </Form.Item>
                </div>
                <Form.Item name="information" className="!mb-0 mt-2 w-full" rules={[{ required: true, message: "Information ist erforderlich" }]}>
                    <BaseInputArea label="Information" onChange={() => {}} disabled={!props.isEditing} minRows={10} />
                </Form.Item>
            </BaseSection>

            {/* Materials */}
            <BaseSection>
                <BaseSectionHeadline label="Materialien" classProps="mt-4 !mb-1" icon={props.isEditing && <PlusCircle className="w-6 h-6 cursor-pointer" onClick={() => props.form.setFieldValue('materials', [...(props.form.getFieldValue('materials') || []), {materialName: '', totalPrice: 0}])} />} />
                {!props.displayedReport?.materials || props.displayedReport?.materials.length === 0 ? (
                    <p className="text-sm text-gray-400 pl-4">Keine Materialien hinzugefügt</p>
                ) : (
                    <Form.List name="materials">
                        {(fields) => (
                            <>
                                {fields.map((field, index) => (
                                    <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mt-2">
                                        <Form.Item name={[field.name, "materialName"]} className="!mb-0 w-full" rules={[{ required: true, message: "Bezeichnung ist erforderlich" }]}>
                                            <BaseInputField label="Bezeichnung" disabled={!props.isEditing} type="text" onChange={() => {}} />
                                        </Form.Item>
                                        <Form.Item name={[field.name, "totalPrice"]} className="!mb-0 w-full" rules={[{ required: true, message: "Gesamtpreis ist erforderlich" }]}>
                                            <BaseInputField label="Gesamtpreis (€)" disabled={!props.isEditing} type="number" onChange={() => {}} />
                                        </Form.Item>
                                    </div>
                                ))}
                            </>
                        )}
                    </Form.List>
                )}

                {/* Documents */}
                <BaseSectionHeadline label="Bilder" classProps="mt-4" />
                {!props.displayedReport?.documents || props.displayedReport?.documents.length === 0 ? (
                        <p className="text-sm text-gray-400 pl-4">Keine Bilder hinzugefügt</p>
                ) : (
                    <div className="space-y-2">
                        {props.displayedReport.documents.map((doc, index) => (
                            <BaseDocElement key={index} label={(doc as any).title ?? "Bild " + index} onDownload={() => props.handleDownload((doc as any).s3Key, (doc as any).title)} onDelete={() => {}} />
                        ))}
                    </div>
                )}
            </BaseSection>
        </>
    )
}
